import { Switch, Text } from "../../../common";
import { SVGProps } from "../../../icons";
import React from "react";
import {
  ServiceItemStyle,
  ServiceItemRightStyle,
  ServiceItemTitleStyle,
  ServiceIconStyle,
  ServiceItemLeftStyle,
} from "../styles";

type Props = {
  title: string;
  subtitle?: string;
  Icons: React.FC<SVGProps>[];
  onSelected: (value: boolean) => void;
  selected?: boolean;
  disabled?: boolean;
  disabledMessage?: string;
};
export const ServiceItem: React.FC<Props> = ({
  title,
  subtitle,
  Icons,
  selected,
  disabled,
  onSelected,
}) => {
  return (
    <div className={ServiceItemStyle}>
      <div className={ServiceItemLeftStyle}>
        <div className={ServiceItemTitleStyle}>
          <Text.Body>{title}</Text.Body>
          {Icons.map((Icon, idx) => (
            <Icon key={idx} style={ServiceIconStyle} />
          ))}
        </div>
        {subtitle && <Text.BodyXS color="seconday">{subtitle}</Text.BodyXS>}
      </div>
      <div className={ServiceItemRightStyle}>
        <Switch
          selected={selected}
          defaultChecked={selected}
          onSelected={onSelected}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
